/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_PlatformsInputs */

const en_why_listening_compare_platforms = /** @type {(inputs: Why_Listening_Compare_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone, Android, Mac, Windows and Chrome`)
};

const es_why_listening_compare_platforms = /** @type {(inputs: Why_Listening_Compare_PlatformsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone, Android, Mac, Windows y Chrome`)
};

/**
* | output |
* | --- |
* | "iPhone, Android, Mac, Windows and Chrome" |
*
* @param {Why_Listening_Compare_PlatformsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_platforms = /** @type {((inputs?: Why_Listening_Compare_PlatformsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_PlatformsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_platforms(inputs)
	return en_why_listening_compare_platforms(inputs)
});